import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-add-animal-general',
  templateUrl: './add-animal-general.component.html',
  styleUrls: ['./add-animal-general.component.css']
})
export class AddAnimalGeneralComponent implements OnInit {
  returnUrl= "/dashboard/RottweilerDogsAnimalmanagement";
  addDiseaseFormValue:any;
  getspeciesvalue:any;
  addgeneralFormValue:any;
  addUrl:any;
  route:any;
  addUrlgeneral:any;
  getlistApi:any;
  getstockListData:any;
  speciesloaddata:any;
  loadspeciesValue:any;
  species:any;
  breeds:any;
  age:any;
  fragment:any;
  loginresponse:any;
  cby_mby:any;
  constructor(private router: Router,private commonService: CommonService) { }

  async ngOnInit() {
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby=this.loginresponse.user_id;
    $('.selectpicker').selectpicker('refresh');
    this.getlistApi= "/species/farms";
    var Animalid=sessionStorage.getItem('animalid');
this.getlistApi= "/stock_management/animal/animal_code/"+Animalid;
(await this.commonService.getApi(this.getlistApi)).subscribe(
  async (res) => {
    this.getstockListData = res.data;
    console.log(res.data[0].species_name)
   this.species=this.getstockListData[0].tnsm_species_id
   this.breeds=this.getstockListData[0].tnsm_breed_id
   this.age=this.getstockListData[0].tnsm_age
   /*if(this.getstockListData[0].tnsm_age==1){
    $("#Age").val('Younger')
   }else{
    $("#Age").val('Grower')
   }*/
    $("#Speciesname").val(this.getstockListData[0].species_name)
    $("#BreedName").val(this.getstockListData[0].breed_name)
    $("#Age").val(this.getstockListData[0].tnsm_age)
    $("#Weight").val(this.getstockListData[0].tnsm_weight)
    var date=this.getstockListData[0].tnsm_date_of_birth;
    var birthdate = date.split('T');
    $("#birthdate").val(birthdate[0]);
    $("#birthdate").text(birthdate[0]);
   // $("#Speciesname").text(this.getstockListData[0].species_name)
    //  $("#BreedName").text(this.getstockListData[0].breed_name)
    sessionStorage.getItem('animalid');
})

      setTimeout(function () {
        $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
     }, 1500);
}
async AnimalGeneral(){
  var farmid=sessionStorage.getItem('farmid');
  var Animalid=sessionStorage.getItem('animalid');

  this.addgeneralFormValue = {
    "species_id":this.species,
    "breed_id": this.breeds,
    "farm_id":farmid,
    "animal_code":Animalid,
    "name":"name",
    "age_group":this.age,
    "sex":$("#gender").val(),
    "weight":$("#Weight").val(),
    "date_of_birth": $("#birthdate").val(),
    "date_of_transfer": $("#transferdate").val(),
    "date_of_purchase": $("#purchasedate").val(),
    "date_of_deletion":$("#deletiondate").val(),
    "date_of_death":$("#deletiondate").val(),
    "cby":this.cby_mby,
    "status": 1,
    "is_active":1
  };
  this.addUrlgeneral = "/animal_management/general";
    (await this.commonService.postApi(this.addUrlgeneral,this.addgeneralFormValue)).subscribe(
      res => {
          alert("Data added successfully");
      });
      setTimeout(
        () : void => {
       
     this.router.navigate([this.returnUrl]);

        },
        500
      );
//}
}

backnavigate(){
  this.router.navigate([this.returnUrl]);
}
}
